module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "task"
    }
  }, [_c('div', {
    staticClass: "entity-card",
    attrs: {
      "id": "deal-form"
    }
  }, [_c('div', {
    staticClass: "md-layout md-gutter entity-card-head"
  }, [_c('div', {
    staticClass: "md-layout-item entity-head-left md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-33"
  }, [_c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('deadline'), 'md-has-value': _vm.task.deadline
    }
  }, [_c('datetime', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "name": "deadline",
      "input-class": "md-input",
      "type": "datetime",
      "use12-hour": false,
      "week-start": 1,
      "phrases": {
        ok: 'Ок',
        cancel: 'Отмена'
      }
    },
    model: {
      value: (_vm.task.deadline),
      callback: function($$v) {
        _vm.$set(_vm.task, "deadline", $$v)
      },
      expression: "task.deadline"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deadline')),
      expression: "errors.has('deadline')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('deadline')))])], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-size-33"
  }, [(_vm.projects && _vm.projects.length) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('project_id')
    }
  }, [_c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "project_id"
    },
    model: {
      value: (_vm.task.project_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "project_id", $$v)
      },
      expression: "task.project_id"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('md-option', {
      key: project.id,
      attrs: {
        "value": project.id
      }
    }, [_vm._v(_vm._s(project.name))])
  }))], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-33"
  }, [(_vm.statuses && _vm.statuses.length) ? _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('status_id')
    }
  }, [_c('md-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "status_id",
      "name": "status_id"
    },
    model: {
      value: (_vm.task.status_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "status_id", $$v)
      },
      expression: "task.status_id"
    }
  }, _vm._l((_vm.statuses), function(status) {
    return _c('md-option', {
      key: status.id,
      attrs: {
        "value": status.id
      }
    }, [_vm._v(_vm._s(status.name))])
  }))], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "md-layout-item entity-head-right"
  }, [_c('md-button', {
    staticClass: "md-primary md-icon-button md-dense close small",
    on: {
      "click": _vm.save
    }
  }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Сохранить")])], 1), _c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    attrs: {
      "to": {
        name: 'Tasks'
      }
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1)], 1)]), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "entity-card-body"
  }, [_c('div', {
    staticClass: "body-head-container"
  }, [(_vm.task.taskmaster) ? _c('div', {
    staticClass: "taskmaster"
  }, [_c('span', [_vm._v("Созданна " + _vm._s(_vm.moment(_vm.task.created_at).calendar() + ' (' + (_vm.task.taskmaster.fio ? _vm.task.taskmaster.fio : _vm.task.taskmaster.login) + ')'))])]) : _vm._e(), (_vm.wasteTime) ? _c('div', {
    staticClass: "waste-time"
  }, [_c('b', [_vm._v(_vm._s(_vm.wasteTime.days + 'дн, ' + _vm.wasteTime.hours + 'ч, ' + _vm.wasteTime.days + 'мин'))])]) : _vm._e()]), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('autocomplete', {
    attrs: {
      "placeholder": "Ответственый",
      "label": "Ответственый*",
      "display-property": "fio",
      "property": "fio",
      "return": "id",
      "showOnFocus": true,
      "callback": _vm.suggestResponsible,
      "items": _vm.responsibles,
      "default": (_vm.task && _vm.task.responsible) ? (_vm.task.responsible.fio) ? _vm.task.responsible.fio : _vm.task.responsible.login : '',
      "required": true,
      "id": "responsible",
      "name": "responsible"
    },
    on: {
      "select": _vm.selectResponsible
    },
    model: {
      value: (_vm.task.responsible_id),
      callback: function($$v) {
        _vm.$set(_vm.task, "responsible_id", $$v)
      },
      expression: "task.responsible_id"
    }
  })], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('multy-autocomplete', {
    attrs: {
      "placeholder": "Исполнители",
      "label": "Исполнители",
      "display-property": "fio",
      "property": "fio",
      "return": "id",
      "showOnFocus": true,
      "callback": _vm.suggestResponsible,
      "id": "coexecutor",
      "name": "coexecutor"
    },
    on: {
      "select": _vm.selectResponsible
    },
    model: {
      value: (_vm.task.coexecutor),
      callback: function($$v) {
        _vm.$set(_vm.task, "coexecutor", $$v)
      },
      expression: "task.coexecutor"
    }
  })], 1)]), _c('multy-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    ref: "groups",
    attrs: {
      "placeholder": "Теги",
      "label": "Теги",
      "display-property": "name",
      "property": "name",
      "return": "id",
      "showOnFocus": true,
      "items": _vm.groups,
      "show-search-input": false,
      "can-add": true,
      "id": "groups",
      "name": "groups",
      "error": _vm.errors.first('groups'),
      "data-vv-name": "groups",
      "data-vv-as": ' '
    },
    on: {
      "select": _vm.selectGroup
    },
    model: {
      value: (_vm.task.groups),
      callback: function($$v) {
        _vm.$set(_vm.task, "groups", $$v)
      },
      expression: "task.groups"
    }
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:50'),
      expression: "'min:3|max:50'"
    }],
    attrs: {
      "name": "group_name",
      "id": "group_name",
      "label": "Название",
      "error": _vm.errors.first('group.group_name'),
      "data-vv-name": "group_name",
      "data-vv-as": ' ',
      "data-vv-scope": "contact"
    },
    model: {
      value: (_vm.newGroup.name),
      callback: function($$v) {
        _vm.$set(_vm.newGroup, "name", $$v)
      },
      expression: "newGroup.name"
    }
  }), _c('md-button', {
    staticClass: "md-primary md-dense",
    on: {
      "click": _vm.saveGroup
    }
  }, [_vm._v("Сохранить")])], 1), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4|max:255'),
      expression: "'required|min:4|max:255'"
    }],
    attrs: {
      "name": "name",
      "id": "name",
      "label": "Название задачи",
      "error": _vm.errors.first('name'),
      "data-vv-as": " ",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.task.name),
      callback: function($$v) {
        _vm.$set(_vm.task, "name", $$v)
      },
      expression: "task.name"
    }
  }), _c('z-markdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:4|max:255'),
      expression: "'min:4|max:255'"
    }],
    attrs: {
      "name": "description",
      "id": "description",
      "label": "Описание",
      "error": _vm.errors.first('description'),
      "data-vv-as": " ",
      "data-vv-name": "description"
    },
    model: {
      value: (_vm.task.description),
      callback: function($$v) {
        _vm.$set(_vm.task, "description", $$v)
      },
      expression: "task.description"
    }
  }), _c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), _c('z-task-checklist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.activeTab == 'tab-check')),
      expression: "(activeTab == 'tab-check')"
    }],
    attrs: {
      "label": "Добавить чек-лист"
    },
    model: {
      value: (_vm.task.checklist),
      callback: function($$v) {
        _vm.$set(_vm.task, "checklist", $$v)
      },
      expression: "task.checklist"
    }
  }), (_vm.task.id && _vm.task.id != 'new' && _vm.user && _vm.user.id) ? _c('z-task-time', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.activeTab == 'tab-timeline')),
      expression: "(activeTab == 'tab-timeline')"
    }],
    attrs: {
      "task-id": _vm.task.id,
      "user-id": _vm.user.id,
      "user": _vm.user
    }
  }) : _vm._e(), (_vm.task.id && _vm.task.id != 'new') ? _c('comments-and-logs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.activeTab == 'tab-comments')),
      expression: "(activeTab == 'tab-comments')"
    }],
    attrs: {
      "entity_id": _vm.task.id,
      "entity": "task",
      "module": "tasks"
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42d19dd6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/views/Task.vue
// module id = 1117
// module chunks = 0